import React, { useCallback, useContext, useState } from 'react'
import { Button, TextField, Dialog, useTheme, useMediaQuery, Box, Typography, InputLabel } from '@mui/material'
import { axiosInstanceMain } from '../../../utils/axiosGlobalUtils'
import { TenantsContext } from '../../../context/tenants.context'
import { crearObservacion } from '../services/admin.local.services'
import { LocalAdminDTO } from '../../../dto/LocalDTO'
import SnackBarUtils from '../../../utils/SnackBarUtils'

interface ObservacionPausarProps {
  open: boolean
  setOpen: (open: boolean) => void
  premise: LocalAdminDTO
  changeLocalStatus: () => Promise<void>
  isAdmin: boolean
  updateLocal: (id: number) => void
}

const MAX_LENGTH = 100

const ObservacionPausar: React.FC<ObservacionPausarProps> = ({
  open,
  setOpen,
  premise,
  changeLocalStatus,
  isAdmin,
  updateLocal
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [observaciones, setObservaciones] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<{ err: boolean; msj: string }>({ err: false, msj: '' })
  const { tenant } = useContext(TenantsContext)

  const handlePausar = () => {
    if (!isAdmin && observaciones === '') return setError({ err: true, msj: 'No puede mandar una observación vacía' })
    pause()
  }

  const handleCrearObsevacion = useCallback(async () => {
    if (observaciones === '') return handleClose()
    try {
      setLoading(true)
      await crearObservacion(tenant, premise.idLocal, ` Se pausa al local porque ${observaciones}`).then((data) => {
        SnackBarUtils.success('Observación publicada correctamente')
        updateLocal(premise.idLocal)
      })
    } catch (error) {
      SnackBarUtils.error('Error al crear observación')
      console.log(error)
    } finally {
      setLoading(false)
      handleClose()
    }
  }, [premise.idLocal, observaciones])

  const pause = () => {
    let url = `/admin/${tenant.path}/locales/${premise.codLocal}/pausar`
    if (observaciones !== '') url += `?observaciones=Se pausa al local porque ${observaciones}`
    axiosInstanceMain
      .post(url)
      .then((result) => {
        changeLocalStatus()
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => handleClose())
  }

  const handleClose = () => {
    setOpen(false)
    setObservaciones('')
    setError({ err: false, msj: '' })
  }

  return (
    <>
      <Dialog
        fullWidth
        open={open}
        PaperProps={{
          style: {
            display: 'flex',
            padding: '20px 20px 10px 20px',
            overflow: 'hidden'
          }
        }}
        onClose={handleClose}
      >
        <InputLabel
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            fontWeight: 'bold'
          }}
        >
          Se pausa al local porque
          <Typography variant="subtitle2">
            {observaciones?.length || 0}/{MAX_LENGTH}
          </Typography>
        </InputLabel>
        <TextField
          disabled={loading}
          label="completá la frase*"
          multiline
          rows={4}
          fullWidth
          value={observaciones}
          onChange={(e) => setObservaciones(e.target.value)}
          sx={{ marginTop: isMobile ? '10px' : '20px' }}
          error={error.err}
          helperText={error.err && error.msj}
          inputProps={{ maxLength: MAX_LENGTH }}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            marginTop: '20px',
            width: '100%',
            gap: '20px',
            justifyContent: 'space-between'
          }}
        >
          <Button disabled={loading} variant="contained" onClick={handleClose} color="error">
            Cancelar
          </Button>
          <Button disabled={loading} variant="contained" onClick={handlePausar} color="success">
            Continuar
          </Button>
        </Box>
      </Dialog>
    </>
  )
}

export default ObservacionPausar
